/// <reference types="@types/googlemaps" />
import {ElementRef, Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

export enum GoogleAutocompletePlaceType {
  ADDRESS = 'address',
  ESTABLISHMENT = 'establishment',
  GEOCODE = 'geocode',
}

export type GoogleAutocomplete = google.maps.places.Autocomplete;
export type GoogleAutocompleteResult = google.maps.places.PlaceResult;

@Injectable({
  providedIn: 'root'
})
export class GoogleAutocompleteService {
  loaded$: Promise<boolean> = null;

  constructor(
    @Inject(PLATFORM_ID) public platformId: string
  ) {
    this.init();
  }

  init(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loaded$ = new Promise(resolve => {
        (window as any).onGoogleLoaded = () => {
          resolve(true);
        };
      });
    }
  }

  isLoaded(): Promise<any> {
    return this.loaded$;
  }

  bind(elementRef: ElementRef, type: GoogleAutocompletePlaceType, countryIsoCode: string | string[]): GoogleAutocomplete {
    const element = elementRef.nativeElement;
    const input = element.querySelector('input') || element.shadowRoot.querySelector('input');
    const autocompleteRef = new google.maps.places.Autocomplete(
      input,
      {
        componentRestrictions: {country: countryIsoCode},
        types: [type],
      }
    );
    input.placeholder = '';
    return autocompleteRef;
  }

  onChanged(autocompleteRef: GoogleAutocomplete, event: (placeResult: GoogleAutocompleteResult) => any) {
    autocompleteRef.addListener('place_changed', () => {
      event(autocompleteRef.getPlace());
    });
  }

  unbindAll(autocompleteRef: GoogleAutocomplete): void {
    autocompleteRef.unbindAll();
  }

  setCountry(autocompleteRef: GoogleAutocomplete, countryIsoCode: string | string[]) {
    autocompleteRef.setComponentRestrictions({
      country: countryIsoCode
    });
  }
}
